import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApiClientModule } from '@ideapa/app-api-client';
import { AppAuthModule } from '@ideapa/app-auth';
import { ENVIRONMENT, VERSION } from '@ideapa/app-common';
import { AppErrorModule } from '@ideapa/app-error';
import { AppFormsModule } from '@ideapa/app-forms';
import { AppKeyboardModule } from '@ideapa/app-keyboard';
import { AppNavigationModule } from '@ideapa/app-navigation';
import { AppNgrxLoaderModule } from '@ideapa/app-ngrx-loader';
import { AppRoutingUtilsModule } from '@ideapa/app-routing-utils';
import { AppUiKitModule } from '@ideapa/app-ui-kit';
import { AppCheckBilanciModule } from '@ideapa/app/check-bilanci';
import { AppNotificationsModule } from '@ideapa/app/notifications';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';
import { NgbDropdown, NgbDropdownAnchor, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap/dropdown';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import moment from 'moment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TabLayoutComponent } from './containers/layout/tab-layout.component';
import { ModalComponent } from './containers/modal/modal.component';
import { allRoutes } from './routes';

// require('default-passive-events');

// eslint-disable-next-line @typescript-eslint/no-var-requires
const version = require('../../../../package.json').version;

@NgModule({
  declarations: [
    AppComponent,
    TabLayoutComponent,
    ModalComponent,
    NavbarComponent,
    FooterComponent,
    SidebarComponent,
  ],
  imports: [
    BrowserModule,
    //routes
    AppRoutingModule,
    //ngrx store
    StoreModule.forRoot(
      {},
      {
        // metaReducers,
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    NgxPermissionsModule.forRoot(),
    EffectsModule.forRoot([]),
    ApiClientModule.forRoot({
      apiEndpoint: environment.apiBaseUrl,
    }),
    AppUiKitModule,
    // FrontendNgrxLoaderModule,
    // RoutingUtilsModule,
    CommonModule,
    AppFormsModule,
    NgbDropdown, NgbDropdownAnchor, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbDropdownButtonItem,
    NgbCollapse,
    AppNgrxLoaderModule,
    AppRoutingUtilsModule,
    AppNavigationModule.forRoot({
      routes: allRoutes,
    }),

    //auth
    AppAuthModule.forRoot({
      tenantId: environment.aadTenantId,
      clientId: environment.aadClientId,
      apiEndpoint: environment.apiBaseUrl,
    }),

    AppErrorModule.forRoot({
      apiEndpoint: environment.apiBaseUrl,
    }),
    AppKeyboardModule.forRoot(),
    // KeyboardShortcutsModule.forRoot(),
    AppNotificationsModule.forRoot(),
    AppCheckBilanciModule.forRoot(),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: ENVIRONMENT, useValue: environment },
    { provide: VERSION, useValue: version },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocaleData(localeIt);
    moment.locale('it');

    // LicenseManager.setLicenseKey(environment.agGridLicenseKey);
  }
}
